import React, { useState, useEffect } from "react";
import { joinArena, fetchTournaments } from "../api/api.js";
import {
    getTournamentData,
    getTournamentDisplayName,
    buildTournamentMap
} from "../utils/tournamentUtils";

const JoinedSquadCard = ({ squad }) => {
    const [expanded, setExpanded] = useState(false);
    const [joiningArenaId, setJoiningArenaId] = useState(null);
    const [tournaments, setTournaments] = useState([]);

    const tournamentMap = buildTournamentMap(tournaments);

    const renderTournamentName = (id) => {
        const t = tournamentMap[id];

        if (!t) {
            return "Unknown tournament";
        }

        return `${getTournamentDisplayName(t.name)} ${t.season}`;
    };

    useEffect(() => {
        const initialize = async () => {
            const { tournaments } =
                await getTournamentData(
                    fetchTournaments
                );

            setTournaments(tournaments);
        };

        initialize();
    }, []);

    const handleJoinArena = async (arenaId) => {
        try {
            setJoiningArenaId(arenaId);

            await joinArena(arenaId);

            squad.arenas = squad.arenas.map((arena) => {

                if (arena.id === arenaId) {
                    return {
                        ...arena,
                        userJoined: true,
                        joinedUsersCount: arena.joinedUsersCount + 1
                    };
                }

                return arena;
            });

        } catch (err) {
            alert(err.message);
        } finally {
            setJoiningArenaId(null);
        }
    };

    return (
        <div className="squad-card">

            {/* HEADER */}
            <div className="squad-header">

                <div className="squad-card-left">
                    <img
                        src={squad.countryFlag}
                        alt={squad.country}
                        title={squad.country}
                        className="squad-country-flag"
                    />
                </div>

                <div className="squad-card-right">

                    <div className="squad-name-row">
                        <div className="squad-name">
                            {squad.name}
                        </div>

                        {squad.userRole === "admin" && (
                            <span className="squad-role-badge">
                                ADMIN
                            </span>
                        )}
                    </div>

                    <div className="squad-admin">
                        admin: {squad.adminUsername}
                    </div>

                    <div className="squad-code">
                        code: {squad.code}
                    </div>
                </div>
            </div>

            {/* FOOTER */}
            <div className="squad-footer">

                <div className="squad-arenas-count">
                    {squad.arenas.length} arenas
                </div>

                <button
                    className="toggle-arenas-button"
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? "Hide arenas ▲" : "Show arenas ▼"}
                </button>
            </div>

            {/* ARENAS */}
            {expanded && (
                <div className="arenas-container">

                    {squad.arenas.length === 0 && (
                        <div className="no-arenas">
                            No arenas yet.
                        </div>
                    )}

                    {squad.arenas.map((arena) => (
                        <div
                            key={arena.id}
                            className="arena-card"
                        >

                            <div className="arena-title">
                                Arena #{arena.id}
                            </div>

                            <div className="arena-tournaments">

                                {arena.enabledTournaments.map((tournament) => (
                                    <div
                                        key={tournament.id}
                                        className="arena-tournament-row"
                                    >
                                        <span className="arena-tournament-name">
                                            {renderTournamentName(tournament.id)}
                                        </span>

                                        <span className="arena-fixture">
                                            from fixture {tournament.fromFixture}
                                        </span>
                                    </div>
                                ))}
                            </div>

                            <div className="arena-users-count">
                                👥 {arena.joinedUsersCount} joined users
                            </div>

                            <div className="arena-action">

                                {arena.userJoined ? (
                                    <div className="arena-joined-label">
                                        JOINED
                                    </div>
                                ) : (
                                    <button
                                        className="submit-button"
                                        disabled={joiningArenaId === arena.id}
                                        onClick={() => handleJoinArena(arena.id)}
                                    >
                                        {joiningArenaId === arena.id
                                            ? "Joining..."
                                            : "Join"}
                                    </button>
                                )}

                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default JoinedSquadCard;